<template>
  <portal to="ModalRecommendation">
    <div class="modal-backdrop py-5">
      <div class="wrapper">
        <div class="card mx-auto pb-3">
          <div class="d-flex justify-content-end pt-3 pr-2 p-lg-2">
            <img
              src="@/assets/icon/close.png"
              alt="close"
              class="pointer"
              @click="$emit('close', 'create')"
            >
          </div>
          <div class="text-center">
            <h5 class="font-weight-bold">
              {{ $t('manage-master-data.company.head-add') }}
            </h5>
          </div>
          <div class="row m-0 px-3 py-1">
            <div class="col-sm-6 pb-1 pb-sm-0">
              <small class="font-weight-bold">
                {{ $t('manage-master-data.company.label.company') }}
              </small>
              <input
                v-model="form.name"
                :class="{'border border-danger': $v.form.name.$error}"
                type="text"
                class="form-control form-control-sm"
              >
              <div
                v-if="!$v.form.required && $v.form.name.$error"
                class="text-danger"
              >
                <small>
                  {{ $t('manage-master-data.company.form-error.company-required') }}
                </small>
              </div>
            </div>
            <div class="col-sm-6 pb-1 pb-sm-0">
              <small class="font-weight-bold">
                {{ $t('manage-master-data.company.label.code') }}
              </small>
              <input
                v-model="form.code"
                type="text"
                class="form-control form-control-sm"
              >
            </div>
          </div>
          <div class="row m-0 px-3 py-1">
            <div class="col-12">
              <small class="font-weight-bold">
                {{ $t('manage-master-data.company.label.contractor') }}
              </small>
              <v-select
                v-model="form.contractors"
                class="sm"
                label="name"
                multiple
                :reduce="getReduceId"
                :options="dataApi.contractors"
              />
            </div>
          </div>
          <div class="row m-0 px-3 py-1">
            <div class="col-12">
              <small class="font-weight-bold">
                {{ $t('manage-master-data.company.label.work-location') }}
              </small>
              <v-select
                v-model="form.workLocations"
                class="sm"
                label="name"
                multiple
                :reduce="getReduceId"
                :options="dataApi.workLocations"
              />
            </div>
          </div>
          <div class="d-flex justify-content-center mt-3">
            <button
              v-if="!isLoadingSubmit"
              class="btn btn-info col-6 col-sm-2"
              @click="submit"
            >
              {{ $t('manage-master-data.save') }}
            </button>
            <button
              v-else
              class="btn btn-info col-6 col-sm-2"
            >
              <div class="spinner-border spinner-border-sm">
                <span class="sr-only">
                  Loading...
                </span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <ModalUnsuccessful
      v-show="modal.unsuccessful"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
    <ModalSuccess
      v-show="modal.success"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
  </portal>
</template>

<script>
import VSelect from 'vue-select'
import Api from '@/utils/Api'
import { required } from 'vuelidate/lib/validators'
import ModalSuccess from '@/components/modal/ModalSuccess'
import ModalUnsuccessful from '@/components/modal/ModalUnsuccessful'

export default {
  components: {
    VSelect,
    ModalSuccess,
    ModalUnsuccessful
  },

  data: () => ({
    dataApi: {
      contractors: [],
      workLocations: []
    },
    form: {
      name: '',
      code: '',
      contractors: [],
      workLocations: []
    },
    modal: {
      textModal: '',
      success: false,
      unsuccessful: false
    },
    isLoadingSubmit: false
  }),

  created () {
    this.getContractors()
    this.getWorkLocations()
  },

  methods: {
    getReduceId: ({ id }) => id,
    async getContractors () {
      const { data } = await Api.contractors.list()
      this.dataApi.contractors = data.data
      this.dataApi.contractors.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    },
    async getWorkLocations () {
      const { data } = await Api.workLocations.list()
      this.dataApi.workLocations = data
      this.dataApi.workLocations.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    },
    showModal (modalname) {
      this.modal[modalname] = true
    },
    closeModal (modalname) {
      this.modal[modalname] = false
      this.$emit('close', 'create')
    },
    async submit () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.isLoadingSubmit = true
        const formRegister = {
          name: this.form.name
        }
        if (this.form.code) {
          formRegister.code = this.form.code
        }
        if (this.form.workLocations.length) {
          formRegister.workLocations = this.form.workLocations
        }
        if (this.form.contractors.length) {
          formRegister.contractors = this.form.contractors
        }
        const data = await Api.companies.add(formRegister)
        this.isLoadingSubmit = false
        if (data.status === 200) {
          this.modal.textModal = this.$t('manage-master-data.company.success-add')
          this.showModal('success')
        } else {
          this.modal.textModal = this.$i18n.locale === 'en' ? data.data.message.messageEng : data.data.message.messageIdn
          this.showModal('unsuccessful')
        }
      }
    }
  },

  validations: {
    form: {
      name: {
        required
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  align-items: center;
  display: flex;
  padding-left: 0;
  z-index: 10;
}
.card {
  margin: 0 auto;
  width: 800px;
  border-radius: 18px;
}
.card-body {
  height: 400px;
}
.pointer {
  cursor: pointer;
}

::v-deep(.vs__dropdown-toggle) {
  background: white;
}

::v-deep(.vs__selected-options) {
  flex-wrap: nowrap;

  .vs--open & {
    flex-wrap: wrap;
  }
}
</style>
